import experiment from 'experiment';

export const isSectionizerEnabled = (): boolean =>
  experiment.isOpen('se_sectionizer');
